import React from 'react';
import { ProgressBar } from '../../../components/ProgressBar';
import { Color } from '../../../app/StyleGuide';
import WhiteLabel from '../../../filters/WhiteLabel';

export const StepsMenuProgressBar = ({ progress }: { progress: number }) => (
  <ProgressBar
    className={WhiteLabel.isGrid() ? '' : 'tl-progress-bar'}
    progress={progress}
    trackColor={Color.Gray._20}
    fillColor={Color.Primary._50}
  />
);
